import * as tslib_1 from "tslib";
import tryRemoveFromMailStoreItems from 'owa-mail-actions/lib/triage/tryRemoveFromMailStoreItems';
import { getAllTableViewsContainingItems } from 'owa-mail-list-actions';
import { getRowKeysFromRowIds } from 'owa-mail-list-store';
import { readingPaneStore } from 'owa-mail-reading-pane-store';
import store from 'owa-mail-store/lib/store/Store';
import { mutator } from 'satcheljs';
export default mutator(tryRemoveFromMailStoreItems, function (actionMessage) {
    var itemId = actionMessage.itemIdToRemove;
    var item = store.items.get(itemId);
    // If the item has already been removed, NOOP
    // Note this can happen right now because reading pane code calls items.delete(itemId) multiple times for the same delete
    // from deleteConversationItemParts and cleanUpItemClientSide.
    if (!item) {
        return;
    }
    var parentConversationId = item.ConversationId.Id;
    var parentFolderId = item.ParentFolderId.Id;
    if (isItemHeldByConversationItemParts(parentConversationId, actionMessage.removeItemSource) ||
        isItemHeldByItemReadingPane(itemId, actionMessage.removeItemSource) ||
        isItemHeldByListViewTable(itemId, item.MailboxInfo, parentFolderId)) {
        // The item reference is currently held, we cannot remove it at this time
        return;
    }
    // Delete the item since it's no longer referenced
    store.items.delete(itemId);
});
export function isItemHeldByConversationItemParts(parentConversationId, removeItemSource) {
    if (removeItemSource == 1 /* ConversationItemParts */) {
        // Don't count the ref held by conversation item parts if this is coming from conversation item parts delete,
        // as it will clean up the ref when the operation fully finishes
        return false;
    }
    // Return true if the item's parent conversation is held in the conversations cache. Because if it is,
    // we can't just delete one of its items even if the RP is not currently displaying it. We want that conversation to
    // remain in a good state if we switch to a prefetched conversation from the cache.
    return !!store.conversations.get(parentConversationId);
}
export function isItemHeldByItemReadingPane(itemId, removeItemSource) {
    if (removeItemSource == 2 /* ItemCleanUp */) {
        // Don't count the ref held by item reading pane if this is coming from item cleanup operation,
        // as it will clean up the ref when the operation fully finishes
        return false;
    }
    return (readingPaneStore.itemReadingPaneViewState &&
        readingPaneStore.itemReadingPaneViewState.itemId == itemId);
}
function isItemHeldByListViewTable(itemId, mailboxInfo, parentFolderId) {
    // Don't check removeItemSource here. Even if it's from a listview table,
    // another listview table may be holding on to this item
    var e_1, _a, e_2, _b;
    var tableViewsForFolder = getAllTableViewsContainingItems(mailboxInfo, parentFolderId, true /* shouldIncludeSearchTable */);
    try {
        for (var tableViewsForFolder_1 = tslib_1.__values(tableViewsForFolder), tableViewsForFolder_1_1 = tableViewsForFolder_1.next(); !tableViewsForFolder_1_1.done; tableViewsForFolder_1_1 = tableViewsForFolder_1.next()) {
            var tableView = tableViewsForFolder_1_1.value;
            if (tableView.tableQuery.listViewType == 0 /* Conversation */) {
                // Only message listviews can hold references to message items
                continue;
            }
            var rowKeys = getRowKeysFromRowIds([itemId], tableView);
            try {
                for (var rowKeys_1 = tslib_1.__values(rowKeys), rowKeys_1_1 = rowKeys_1.next(); !rowKeys_1_1.done; rowKeys_1_1 = rowKeys_1.next()) {
                    var rowKey = rowKeys_1_1.value;
                    if (tableView.rowKeys.indexOf(rowKey) >= 0) {
                        return true;
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (rowKeys_1_1 && !rowKeys_1_1.done && (_b = rowKeys_1.return)) _b.call(rowKeys_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (tableViewsForFolder_1_1 && !tableViewsForFolder_1_1.done && (_a = tableViewsForFolder_1.return)) _a.call(tableViewsForFolder_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return false;
}
//# sourceMappingURL=tryRemoveFromMailStoreItemsMutator.js.map